export const getAPIBaseURL = () => {
  if (window.location.hostname === 'localhost') {
    // return 'https://webapp.aryballe.com/api'
    return 'http://localhost:8038';
  }
  return 'https://prod.api.webapp.aryballe.com';
};

enum ApiResponseType {
  JSON = 'json',
  ArrayBuffer = 'arraybuffer',
}

export interface ApiErrorType {
  Reason: string;
}

export const getDohFrontBaseUrl = () => {
  if (window.location.hostname === 'localhost') {
    return 'https://localhost:8080';
  } else if (window.location.hostname === 'staging.m.webapp.aryballe.com') {
    return 'https://mambo.hub.aryballe.com';
  }
  return 'https://hub.aryballe.com';
};
